import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';
import { FieldValue } from '../../../../../../types/QueryBuilder';
import SelectedItemRow from '../SelectedItemRow';
import { BORDERED_BOX_SX } from '../valueUtils';

interface DualListPanelProps {
    title: string;
    color: string;
    items: FieldValue[];
    emptyLabel: string;
    boxSx: SxProps<Theme>;
    onRemove?: (name: string) => void;
    chips?: boolean;
}

function DualListPanel({ title, color, items, emptyLabel, boxSx, onRemove, chips = false }: DualListPanelProps) {
    return (
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color }}>
                {title} {chips && `(${items.length})`}
            </Typography>
            <Box sx={{ ...BORDERED_BOX_SX, overflowY: 'auto', overflowX: 'hidden', px: 1, py: 0.5, ...boxSx }}>
                {items.length === 0 ? (
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {emptyLabel}
                    </Typography>
                ) : (
                    items.map(item => (chips ? (
                        <Chip
                            key={item.name}
                            size="small"
                            sx={{ m: 0.25, maxWidth: '100%' }}
                            label={item.label}
                            onDelete={onRemove && (() => onRemove(item.name))}
                        />
                    ) : (
                        <SelectedItemRow key={item.name} label={item.label} onRemove={onRemove && (() => onRemove(item.name))} />
                    )))
                )}
            </Box>
        </Box>
    );
}

export default DualListPanel;
